import isProduction from 'utils/isProduction';

const BUSINESS_IDS_WITH_PROJECT_EMAIL = [
  '0977134-6', // ESJP
  '2624244-6', // Lixani
  '3223682-7', // Paaso Capital
  '3586419-1', // AirLounge
  '123',
];

const isProjectEmailEnabled = (project) => {
  if (!isProduction) {
    return true;
  }
  return BUSINESS_IDS_WITH_PROJECT_EMAIL.includes(project.business_id);
};

export default isProjectEmailEnabled;
